import { Observable } from 'rxjs';
import {
  Actions,
  EffectNotification,
  ofType,
  OnRunEffects,
} from '@ngrx/effects';
import { resetAuth, setAuthUser } from './auth.actions';
import { exhaustMap, takeUntil } from 'rxjs/operators';

export class AuthRunEffects implements OnRunEffects {
  constructor(protected actions$: Actions) {}

  ngrxOnRunEffects(
    resolvedEffects$: Observable<EffectNotification>,
  ): Observable<EffectNotification> {
    return this.actions$.pipe(
      ofType(setAuthUser),
      exhaustMap(() =>
        resolvedEffects$.pipe(takeUntil(this.actions$.pipe(ofType(resetAuth)))),
      ),
    );
  }
}
